<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <mat-slide-toggle [(ngModel)]="options.hideFields" color="primary">
    Hide empty fields
  </mat-slide-toggle>

  <div class="form-container">
    <ng-template formHost></ng-template>
  </div>

  <button (click)="onSave()" *ngIf="!!boundImport" mat-button>Save</button>
</page-content>
